<template>
    <ValidationObserver ref="form" #default="{ invalid }">
        <BForm @submit.prevent="onSubmit">
            <BRow class="mb-3">
                <TextInputValidated vsName="Name" :vsModel.sync="formData.name" vsLabel="name" vsMd="12" vsRequired vsRules="required" />
            </BRow>
            <BButton variant="primary" @click="onSubmit">Guardar</BButton>
        </BForm>
    </ValidationObserver>
</template>

<script>
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import { addContactSource } from '@/composables/contactSourceService';
import { ref } from '@vue/composition-api';
import { BButton, BForm, BRow } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationObserver, BForm, BRow, TextInputValidated, BButton
    },
    setup() {
        const formData = ref({
            name: ''
        })

        const add = async function() {
            const resp = await addContactSource(formData.value)
            console.log(resp);
        }

        const onSubmit = async function() {
            this.$refs.form.validate().then(success => {
                if (success) {
                    add()
                }
            })
        }

        return {
            formData,
            onSubmit
        }
    }
}
</script>